module.exports = __webpack_public_path__ + "img/flag_3regions.cd990331.svg";